import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { Button, Dialog, RadioButton } from '@dsi/react-eds';
import { PipelineItem, PipelineStatus, PipelineStep } from '../../const/PipelineTypes';
import { useTestingCompletedForm } from '../TestAutomation/testing-completed-form';
import { Controller } from 'react-hook-form';

interface TestingCompletedDialogProps {
  open: boolean;
  pipeline: PipelineItem | null;
  step: PipelineStep | null;
  onClose: () => void;
  onStatusSubmit: (status: PipelineStatus, pipeline: PipelineItem, step: PipelineStep) => void;
}

export default function TestingCompletedDialog({
  open,
  pipeline,
  step,
  onClose,
  onStatusSubmit
}: TestingCompletedDialogProps) {

  const {
      formState: { isValid },
      reset,
      control,
      getValues
    } = useTestingCompletedForm();

  const handleFormSubmit = async (data: { status: string }) => {
    if (pipeline && step){
      const status = Object.values(PipelineStatus).find(ps => ps === data.status);
      if (status) {
        onStatusSubmit(status, pipeline, step);
        reset(); 
      }
    }
  }

  return (
    <ReactEDSWrapper 
      component={Dialog}
      show={open}
      onClose={() => {
        reset(); 
        onClose();
      }}
      title={`Testing Completed`} 
      bottom={
        <>
          <ReactEDSWrapper
            component={Button}
            variant="primary"
            className="btn primary"
            type="button"
            disabled={!isValid}
            onClick={() => {
              if (pipeline && step){
                handleFormSubmit(getValues())
              }
            }}
          >
            Apply
          </ReactEDSWrapper>
        </>
      }>
      <div>
        Please select the outcome generated during the test execution.        
        <br /><br />
        <form id="testing-completed-form" >
          <Controller
            name="status"
            control={control}
            render={({ field }) => (
              <>
                <ReactEDSWrapper 
                component={RadioButton} 
                id='success-radio' 
                name='status-radio' 
                value={PipelineStatus.Success}
                checked={field.value === PipelineStatus.Success}
                onChange={() => field.onChange(PipelineStatus.Success)}
                >
                  Success - All test cases executed succesfully (100% pass rate)
              </ReactEDSWrapper>
              <ReactEDSWrapper 
                component={RadioButton} 
                id='failure-radio' 
                name='status-radio' 
                value={PipelineStatus.Failure}
                checked={field.value === PipelineStatus.Failure}
                onChange={() => field.onChange(PipelineStatus.Failure)}
                >
                  Failed - The test execution encountered errors that prevented successful completion.
              </ReactEDSWrapper>
              <ReactEDSWrapper 
                component={RadioButton} 
                id='warning-radio' 
                name='status-radio' 
                value={PipelineStatus.Warning}
                checked={field.value === PipelineStatus.Warning}
                onChange={() => field.onChange(PipelineStatus.Warning)}
                >
                  Warning - One or more test cases failed or were skipped during execution.
              </ReactEDSWrapper>
              </>
            )}
          />
        </form>
      </div>
    </ReactEDSWrapper>
    
  );
}